var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHockeyPuck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 80C112.453 80 0 122.156 0 176V336C0 389.844 112.453 432 256 432S512 389.844 512 336V176C512 122.156 399.547 80 256 80ZM256 96C399.562 96 496 137.375 496 176S399.562 256 256 256S16 214.625 16 176S112.438 96 256 96ZM496 336C496 374.625 399.562 416 256 416S16 374.625 16 336V209.734C51.717 246.426 144.309 272 256 272S460.283 246.426 496 209.734V336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockeyPuck);
export default __webpack_public_path__ + "static/media/hockey-puck.85e5028e2d9216e7835d6640d76c60d6.svg";
export { ForwardRef as ReactComponent };